import { makeAutoObservable } from 'mobx'

import { KyrgyzstanCollectionsApi } from 'shared/api/kyrgyzstan/collections'
import { getApiErrorMessage } from 'shared/lib/errorText'

import type { KyrgyzstanCollectionItem } from './types'

class KyrgyzstanCollectionsStore {
  items: KyrgyzstanCollectionItem[] = []

  isLoading = false

  error: string | null = null

  isLoaded = false

  constructor() {
    makeAutoObservable(this)
  }

  getCollections() {
    return this.items
  }

  getCollectionById(id: string) {
    return this.items.find((item) => item.id === id)
  }

  async load() {
    if (this.isLoading) {
      return
    }

    this.isLoading = true
    this.error = null

    try {
      const { data: response } = await KyrgyzstanCollectionsApi.getCollections()

      this.items = response.data.collections
      this.isLoaded = true
    } catch (error: unknown) {
      this.error = getApiErrorMessage(error)
      this.items = []
      this.isLoaded = true
    } finally {
      this.isLoading = false
    }
  }

  loadIfNeeded() {
    if (this.isLoaded || this.isLoading) {
      return
    }

    this.load()
  }
}

export const kyrgyzstanCollectionsStore = new KyrgyzstanCollectionsStore()
